import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import Me from "../helpers/me";
import App from "../helpers/app";
import Api from "../helpers/api";
import {take} from "rxjs/operators";
import {ExcelService} from "../helpers/excel.service";
import { Location } from '@angular/common';
import { BreadcrumbService } from '../shared/services/breadcrumb.service';
import * as moment from "moment";

@Component({
  selector: 'app-relatorios-municipio',
  templateUrl: './relatorios-municipio.component.html',
  styleUrls: ['./relatorios-municipio.component.scss']
})
export class RelatoriosMunicipioComponent implements OnInit {
  apiCall = this.api.new().silent();
  page = 1
  pageSize = 10
  tipos = [
    {
      id: "0",
      descricao: "Todos"
    },
    {
      id: "1",
      descricao: "Sexo"
    },
    {
      id: "2",
      descricao: "Idade"
    },
    {
      id: "3",
      descricao: "Quantidade Dependentes"
    },
    {
      id: "4",
      descricao: "Tempo Total Serviço"
    },
    {
      id: "5",
      descricao: "Data Nascimento"
    },
    {
      id: "6",
      descricao: "Data Nascimento Dependentes"
    },
    {
      id: "7",
      descricao: "Dependentes"
    },
    {
      id: "8",
      descricao: "Lista de Tempo de Serviço"
    },
    {
      id: "9",
      descricao: "Total de Tempo de Serviço por Servidor"
    },
    {
      id: "10",
      descricao: "Listagem Geral"
    },
    {
      id: "11",
      descricao: "Servidores com Múltiplas Matrículas"
    },
    {
      id: "12",
      descricao: "Atendimentos"
    },
    {
      id: "13",
      descricao: "Arquivos Servidor"
    },
    {
      id: "14",
      descricao: "Prova de Vida"
    },
    {
      id: "15",
      descricao: "Pendências"
    },
  ]
  // Status de servidor para a Prova de Vida (Exato)
  statusServidorOpcoes = [
    { id: 'todos', descricao: 'Todos' },
    { id: 'ativos', descricao: 'Ativos' },
    { id: 'aposentados', descricao: 'Aposentados' },
    { id: 'pensionistas', descricao: 'Pensionistas' },
  ]
  statusServidorProvaVida = 'todos'
  // Estado do processamento paginado da Prova de Vida
  tamanhoLoteProvaVida = 30
  provaVidaEmAndamento = false
  provaVidaProcessados = 0
  provaVidaTotal = 0
  provaVidaPaginaAtual = 0
  provaVidaTotalPaginas = 0
  sexos = [

    {
      id: 'M',
      name: 'Masculino',
    },{
      id: 'F',
      name: 'Feminino',
    }]
  servidores = []
  servidoresFiltered = []
  servidoresModeloPadraoFiltered = []
  cidade
  nomeFiltro = '';
  statusRelatorio = '0'
  sexo = null
  idade = null
  quantidade_dependente = null
  tempoMinimo = null
  tempoMaximo = null
  dataNascimentoMinima = null
  dataNascimentoMaxima = null
  dataNascimentoDependenteMinima = null
  dataNascimentoDependenteMaxima = null
  dependentes = []
  dependentesFiltered = []
  temposServico = []
  temposServicoFiltered = []
  servidoresComTotais = []
  servidoresComTotaisFiltered = []
  listagemGeral = []
  listagemGeralFiltered = []
  multiplasMatriculas = []
  multiplasMatriculasFiltered = []
  atendimentos = []
  atendimentosFiltered = []
  arquivosServidores = []
  arquivosServidoresFiltered = []
  pendencias = []
  pendenciasFiltered = []

  // Propriedades para municípios
  cidades = [];
  cidadeEscolhida = null;
  nomeCidade = '';
  desabilitaRelatorio = true;
  
  // Propriedades para relatório SPREV
  servidoresAtivos = [];
  servidoresInativos = [];
  servidoresPensionistas = [];
  
  tipoDeFundo = [
    {
      id: 1,
      valor: "Fundo em Capitalização",
    },
    {
      id: 1,
      valor: "Sem Segregação da Massa",
    },
    {
      id: 2,
      valor: "Fundo em Repartição (em caso de Segregação da Massa)",
    },
    {
      id: 3,
      valor:
        "Beneficiário sob responsabilidade direta do ente federativo ('Mantidos pelo Tesouro')",
    },
  ];

  poder = [
    { id: 1, valor: "Executivo" },
    { id: 2, valor: "Legislativo" },
    { id: 3, valor: "Judiciário" },
    { id: 4, valor: "Ministério Público" },
    { id: 5, valor: "Tribunal de Contas" },
    { id: 6, valor: "Defensoria Pública" },
  ];

  tipoPoder = [
    { id: 1, valor: "Administração Direta" },
    { id: 1, valor: "Administração Indireta" },
  ];
  
  // Propriedades para ordenação
  currentSortColumn: string = '';
  currentSortDirection: string = 'asc';

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private excelService:ExcelService,
    private me: Me,
    private app: App,
    private api: Api,
    private location: Location,
    private breadcrumbService: BreadcrumbService,
    private cdr: ChangeDetectorRef
  ) {
  }

  goBack() {
    this.location.back();
  }

  async ngOnInit(){
    const self = this
    self.servidores = []
    self.servidoresFiltered = []
    self.servidoresModeloPadraoFiltered = []
    self.dependentes = []
    self.dependentesFiltered = []
    self.temposServico = []
    self.temposServicoFiltered = []
    self.servidoresComTotais = []
    self.servidoresComTotaisFiltered = []
    self.listagemGeral = []
    self.listagemGeralFiltered = []
    self.multiplasMatriculas = []
    self.multiplasMatriculasFiltered = []
    self.atendimentos = []
    self.atendimentosFiltered = []
    self.arquivosServidores = []
    self.arquivosServidoresFiltered = []
    self.pendencias = []
    self.pendenciasFiltered = []

    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    
    // Carregar lista de cidades
    const cidades = await self.apiCall
      .get("servidor/getCidades")
      .pipe(take(1))
      .toPromise();
    self.cidades = cidades;
    
    // Verificar parâmetro da URL
    self.route.queryParams.subscribe( parametros => {
      if (parametros['idCidade']) {
        self.cidadeEscolhida = Number(parametros['idCidade']);
        self.cidade = Number(parametros['idCidade']);
        self.nomeCidade = self.cidades.find(x => x.id == self.cidadeEscolhida)?.nome || '';
        self.desabilitaRelatorio = false;
        // Configurar breadcrumbs quando tiver cidade
        self.breadcrumbService.setMunicipioBreadcrumbs('Relatórios', Number(self.cidade));
        // Carregar dados se cidade estiver selecionada
        self.carregarDados();
      }
    });
    
    this.spinner.hide();
  }

  async carregarDados() {
    const self = this;
    if (self.cidadeEscolhida) {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await self.apiCall.get('servidor/relatorio/todos?id_cidade='+self.cidadeEscolhida).pipe(take(1)).toPromise()
      const servidoresModeloPadrao = await self.apiCall.get('servidor/relatorio/modelopadrao?id_cidade='+self.cidadeEscolhida).pipe(take(1)).toPromise()
      this.spinner.hide()
      self.servidores = JSON.parse(JSON.stringify(servidores));
      self.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      self.servidoresModeloPadraoFiltered = JSON.parse(JSON.stringify(servidoresModeloPadrao));
    }
  }

  changeCidade($event) {
    // Garantir que $event seja sempre um número (ID da cidade)
    const cidadeId = typeof $event === 'object' ? $event?.id : $event;
    this.cidadeEscolhida = cidadeId;
    this.cidade = cidadeId;
    this.nomeCidade = this.cidades.find(x => x.id == this.cidadeEscolhida)?.nome || '';
    
    if (this.cidadeEscolhida === null || this.cidadeEscolhida === undefined) {
      this.desabilitaRelatorio = true;
    } else {
      this.desabilitaRelatorio = false;
      this.carregarDados();
    }
  }

  // Método para ordenação das colunas
  sortTable(column: string) {
    // Verificar se é a mesma coluna
    if (this.currentSortColumn === column) {
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = column;
      this.currentSortDirection = 'asc';
    }

    // Ordenar os dados localmente
    let dataToSort;
    if(this.statusRelatorio === '7'){
      dataToSort = this.dependentesFiltered;
    } else if(this.statusRelatorio === '8'){
      dataToSort = this.temposServicoFiltered;
    } else if(this.statusRelatorio === '9'){
      dataToSort = this.servidoresComTotaisFiltered;
    } else if(this.statusRelatorio === '10'){
      dataToSort = this.listagemGeralFiltered;
    } else if(this.statusRelatorio === '11'){
      dataToSort = this.multiplasMatriculasFiltered;
    } else if(this.statusRelatorio === '12'){
      dataToSort = this.atendimentosFiltered;
    } else if(this.statusRelatorio === '13'){
      dataToSort = this.arquivosServidoresFiltered;
    } else if(this.statusRelatorio === '15'){
      dataToSort = this.pendenciasFiltered;
    } else {
      dataToSort = this.servidoresFiltered;
    }
    dataToSort.sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];

      // Tratamento especial para diferentes tipos de dados
      if (column === 'data_nascimento') {
        // Converter data para objeto Date para comparação
        valueA = new Date(valueA.split('/').reverse().join('-'));
        valueB = new Date(valueB.split('/').reverse().join('-'));
      } else if (typeof valueA === 'string') {
        valueA = valueA.toLowerCase();
        valueB = valueB.toLowerCase();
      }

      let comparison = 0;
      if (valueA > valueB) {
        comparison = 1;
      } else if (valueA < valueB) {
        comparison = -1;
      }

      return this.currentSortDirection === 'desc' ? comparison * -1 : comparison;
    });
  }

  // Método para mostrar indicador de ordenação
  getSortIcon(column: string): string {
    if (this.currentSortColumn === column) {
      return this.currentSortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
    }
    return '';
  }

  // Método para verificar se a coluna está sendo ordenada
  isColumnSorted(column: string): boolean {
    return this.currentSortColumn === column;
  }

  async alternarRelatorio(){
    this.sexo = null
    this.idade = null
    this.quantidade_dependente = null
    this.tempoMinimo = null
    this.tempoMaximo = null
    this.dataNascimentoMinima = null
    this.dataNascimentoMaxima = null
    this.dataNascimentoDependenteMinima = null
    this.dataNascimentoDependenteMaxima = null
    this.dependentes = []
    this.dependentesFiltered = []
    this.temposServico = []
    this.temposServicoFiltered = []
    this.servidoresComTotais = []
    this.servidoresComTotaisFiltered = []
    this.listagemGeral = []
    this.listagemGeralFiltered = []
    this.multiplasMatriculas = []
    this.multiplasMatriculasFiltered = []
    this.atendimentos = []
    this.atendimentosFiltered = []
    this.arquivosServidores = []
    this.arquivosServidoresFiltered = []
    this.pendencias = []
    this.pendenciasFiltered = []
    if(this.statusRelatorio=='14'){
      // Prova de Vida: os dados são gerados sob demanda pelo botão "Gerar prova de vida".
      // Limpa a tabela padrão de servidores para não exibir dados antigos.
      this.statusServidorProvaVida = 'todos'
      this.servidores = []
      this.servidoresFiltered = []
    }
    if(this.statusRelatorio=='0'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get('servidor/relatorio/todos?id_cidade='+this.cidadeEscolhida).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
    if(this.statusRelatorio=='7'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const dependentes = await this.apiCall.get('servidor/relatorio/dependentes_servidores?id_cidade='+this.cidadeEscolhida).pipe(take(1)).toPromise()
      this.dependentes = JSON.parse(JSON.stringify(dependentes));
      this.dependentesFiltered = JSON.parse(JSON.stringify(dependentes));
      this.spinner.hide();
    }
    if(this.statusRelatorio=='8'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const temposServico = await this.apiCall.get('servidor/relatorio/tempos_servico_servidores?id_cidade='+this.cidadeEscolhida).pipe(take(1)).toPromise()
      console.log('Dados recebidos do endpoint tempos_servico_servidores:', temposServico);
      this.temposServico = JSON.parse(JSON.stringify(temposServico));
      this.temposServicoFiltered = JSON.parse(JSON.stringify(temposServico));
      this.spinner.hide();
    }
    if(this.statusRelatorio=='9'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidoresComTotais = await this.apiCall.get('servidor/relatorio/servidores_com_totais?id_cidade='+this.cidadeEscolhida).pipe(take(1)).toPromise()
      console.log('Dados recebidos do endpoint servidores_com_totais:', servidoresComTotais);
      this.servidoresComTotais = JSON.parse(JSON.stringify(servidoresComTotais));
      this.servidoresComTotaisFiltered = JSON.parse(JSON.stringify(servidoresComTotais));
      this.spinner.hide();
    }
    if(this.statusRelatorio=='10'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const listagemGeral = await this.apiCall.get('servidor/relatorio/municipio?id_cidade='+this.cidadeEscolhida).pipe(take(1)).toPromise()
      console.log('Dados recebidos do endpoint municipio:', listagemGeral);
      this.listagemGeral = JSON.parse(JSON.stringify(listagemGeral));
      this.listagemGeralFiltered = JSON.parse(JSON.stringify(listagemGeral));
      this.spinner.hide();
    }
    if(this.statusRelatorio=='11'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      
      // Fazer as 2 chamadas em paralelo
      const [tipo1, tipo2] = await Promise.all([
        this.apiCall.get(`servidor/relatorio/multiplos-movimentos/tipo/1?idCidade=${this.cidadeEscolhida}`).pipe(take(1)).toPromise(),
        this.apiCall.get(`servidor/relatorio/multiplos-movimentos/tipo/2?idCidade=${this.cidadeEscolhida}`).pipe(take(1)).toPromise()
      ]);
      
      console.log('Dados recebidos do endpoint multiplos-movimentos tipo 1:', tipo1);
      console.log('Dados recebidos do endpoint multiplos-movimentos tipo 2:', tipo2);
      
      // Combinar os resultados das 2 chamadas
      const multiplasMatriculas = [
        ...(tipo1 || []),
        ...(tipo2 || [])
      ];
      
      this.multiplasMatriculas = JSON.parse(JSON.stringify(multiplasMatriculas));
      this.multiplasMatriculasFiltered = JSON.parse(JSON.stringify(multiplasMatriculas));
      this.spinner.hide();
    }
    if(this.statusRelatorio=='12'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const atendimentos = await this.apiCall.get('servidor/atendimento/relatorio?id_cidade='+this.cidadeEscolhida).pipe(take(1)).toPromise()
      console.log('Dados recebidos do endpoint atendimentos:', atendimentos);
      this.atendimentos = JSON.parse(JSON.stringify(atendimentos));
      this.atendimentosFiltered = JSON.parse(JSON.stringify(atendimentos));
      this.spinner.hide();
    }
    if(this.statusRelatorio=='13'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const arquivos = await this.apiCall.get('servidor/relatorio/arquivos?id_cidade='+this.cidadeEscolhida).pipe(take(1)).toPromise()
      const lista = (arquivos as any[] || []).map((linha) => ({
        id: linha.id_servidor,
        nome: linha.nome,
        cpf: linha.cpf,
        rg: linha.rg && linha.rg !== 'null' ? linha.rg : '',
        matricula: linha.matricula && linha.matricula !== 'null' ? linha.matricula : '',
        arquivo: linha.arquivo_nome || '',
      }));
      this.arquivosServidores = JSON.parse(JSON.stringify(lista));
      this.arquivosServidoresFiltered = JSON.parse(JSON.stringify(lista));
      this.spinner.hide();
    }
    if(this.statusRelatorio=='15'){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const pendencias = await this.apiCall.get('servidor/relatorio/pendencias_servidores?id_cidade='+this.cidadeEscolhida).pipe(take(1)).toPromise()
      this.pendencias = JSON.parse(JSON.stringify(pendencias));
      this.pendenciasFiltered = JSON.parse(JSON.stringify(pendencias));
      this.spinner.hide();
    }
  }
  async pesquisarPorSexo(){
    if(this.sexo){
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/sexo?id_cidade=${this.cidadeEscolhida}&sexo=${this.sexo}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorIdade(){
    if(this.idade){
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/idade?id_cidade=${this.cidadeEscolhida}&idade_minima=${this.idade}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorTempoMinimo(){
    if(this.tempoMinimo && this.tempoMaximo) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/tempo_servico_total?id_cidade=${this.cidadeEscolhida}&tempo_minimo=${this.tempoMinimo}&tempo_maximo=${this.tempoMaximo}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorTempoMaximo(){
    if(this.tempoMinimo && this.tempoMaximo) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/tempo_servico_total?id_cidade=${this.cidadeEscolhida}&tempo_minimo=${this.tempoMinimo}&tempo_maximo=${this.tempoMaximo}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorQuantidadeDependentes(){
    if(this.quantidade_dependente){
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/quantidade_dependentes?id_cidade=${this.cidadeEscolhida}&quantidade=${this.quantidade_dependente}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorDataNascimentoMinimoDatePicker(){
    console.log(this.dataNascimentoMinima)
    console.log(this.dataNascimentoMaxima)
    if(this.dataNascimentoMinima && this.dataNascimentoMaxima) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/data_nascimento?id_cidade=${this.cidadeEscolhida}&data_nascimento_inicio=${this.dataNascimentoMinima}&data_nascimento_fim=${this.dataNascimentoMaxima}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorDataNascimentoMinimo(){
    if(this.dataNascimentoMinima && this.dataNascimentoMaxima) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/data_nascimento?id_cidade=${this.cidadeEscolhida}&data_nascimento_inicio=${this.dataNascimentoMinima}&data_nascimento_fim=${this.dataNascimentoMaxima}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }

  }
  gerarRelatorio(){
    if (this.desabilitaRelatorio) {
      return;
    }
    if(this.statusRelatorio == '7'){
      this.excelService.exportAsExcelFile(this.dependentesFiltered, 'dependentes_servidores');
    } else if(this.statusRelatorio == '8'){
      // Padronizar o campo tempo_em_sala_aula antes da exportação
      const dadosPadronizados = this.temposServicoFiltered.map(item => {
        // Verificar qual campo existe (pode ser tempo_em_sala_aula ou tempo_em_sala_de_aula)
        const campoOriginal = item.tempo_em_sala_aula !== undefined ? 'tempo_em_sala_aula' : 
                             item.tempo_em_sala_de_aula !== undefined ? 'tempo_em_sala_de_aula' : 
                             'tempo_em_sala_aula';
        
        const { [campoOriginal]: valorOriginal, ...resto } = item;
        return {
          ...resto,
          tempo_em_sala_aula: this.padronizarSimNao(valorOriginal)
        };
      });
      console.log('Dados padronizados para exportação:', dadosPadronizados);
      this.excelService.exportAsExcelFile(dadosPadronizados, 'tempos_servico_servidores');
    } else if(this.statusRelatorio == '9'){
      // Garantir que campos zerados mostrem 0 em vez de ficarem em branco
      const dadosPadronizados = this.servidoresComTotaisFiltered.map(item => {
        return {
          ...item,
          status: item.status || 'Não informado',
          tempo_total_em_dias: item.tempo_total_em_dias || 0,
          tempo_total_em_sala_de_aula: item.tempo_total_em_sala_de_aula || 0,
          tempo_total_nao_em_sala_de_aula: item.tempo_total_nao_em_sala_de_aula || 0
        };
      });
      console.log('Dados padronizados para exportação (servidores_com_totais):', dadosPadronizados);
      this.excelService.exportAsExcelFile(dadosPadronizados, 'servidores_com_totais');
    } else if(this.statusRelatorio == '10'){
      this.excelService.exportAsExcelFile(this.listagemGeralFiltered, 'listagem_geral');
    } else if(this.statusRelatorio == '11'){
      this.excelService.exportAsExcelFile(this.multiplasMatriculasFiltered, 'servidores_multiplas_matriculas');
    } else if(this.statusRelatorio == '12'){
      this.excelService.exportAsExcelFile(this.atendimentosFiltered, 'atendimentos');
    } else if(this.statusRelatorio == '13'){
      this.excelService.exportAsExcelFile(JSON.parse(JSON.stringify(this.arquivosServidoresFiltered)), 'arquivos_servidor');
    } else if(this.statusRelatorio == '15'){
      this.excelService.exportAsExcelFile(JSON.parse(JSON.stringify(this.pendenciasFiltered)), 'pendencias_servidores');
    } else {
      this.excelService.exportAsExcelFile(this.servidoresFiltered, 'servidores');
    }
  }
  gerarModeloPadrao(){
    if (!this.desabilitaRelatorio) {
      this.excelService.exportAsExcelFile(this.servidoresModeloPadraoFiltered, 'relatorio_modelo_padrao');
    }
  }

  async gerarRelatorioSPREV() {
    const self = this;
    if (self.cidadeEscolhida) {
      this.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
      
      const servidores = await this.apiCall
        .get(`servidor/relatorio/brprev?id_cidade=${self.cidadeEscolhida}`)
        .pipe(take(1))
        .toPromise();
        
      if (!servidores) {
        this.spinner.hide();
        return;
      }

      console.log("servidores", servidores);
      self.servidoresAtivos = [];
      self.servidoresPensionistas = [];
      self.servidoresInativos = [];
      let servidoresPorAno = servidores;
      
      for (let servidor of servidoresPorAno) {
        //Declarações e formatação de campos
        let tipoFundo = null;
        let poder = null;
        let tipoPoder = null;
        let bPopulacaoCoberta = null;
        let cPopulacaoCoberta = null;

        if (this.tipoDeFundo.find((t) => t.valor == servidor.fundo)) {
          tipoFundo = this.tipoDeFundo.find(
            (t) => t.valor == servidor.fundo
          ).id;
        }

        if (this.poder.find((t) => t.valor == servidor.poder)) {
          poder = this.poder.find((t) => t.valor == servidor.poder).id;
        }

        if (this.tipoPoder.find((t) => t.valor == servidor.tipo_poder)) {
          tipoPoder = this.tipoPoder.find(
            (t) => t.valor == servidor.tipo_poder
          ).id;
        }

        if (servidor.status !== null && servidor.status == 1) {
          if (servidor.carreira == 6) {
            bPopulacaoCoberta = 2;
          } else {
            bPopulacaoCoberta = 7;
          }
  
          if (servidor.populacao_coberta_c) {
            cPopulacaoCoberta = 3;
            if (servidor.populacao_coberta_c == "Como Professor") {
              cPopulacaoCoberta = 3;
            } else {
              cPopulacaoCoberta = 1;
            }
          }

          // Verificar se o servidor é recenseado
          const recenseado = servidor.inicio_atendimento ? "Sim" : "Não";
          const identificacaoCarreiraAtual = servidor.carreira == 6 ? 2 : 7;

          let data = {
            ANO: servidor.ano,
            MÊS: servidor.mes,
            CO_IBGE: servidor.ibge,
            NOME_DO_ENTE: servidor.nome_cidade,
            SIGLA_ESTADO: servidor.estado_naturalidade,
            "COMPOSIÇÃO DA MASSA (A)": "1",
            "TIPO DO FUNDO (B)": tipoFundo ? tipoFundo : "",
            CNPJ: servidor.cnpj,
            "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
            PODER: poder ? poder : "",
            TIPO: tipoPoder ? tipoPoder : "",
            "A - POPULAÇÃO COBERTA":
              servidor.carreira == "21" ? "Militares em atividade" : "Ativos",
            "B- POPULAÇÃO COBERTA": bPopulacaoCoberta,
            "C - POPULAÇÃO COBERTA": cPopulacaoCoberta,
            Matrícula: servidor.matricula,
            CPF: servidor.cpf,
            "PIS-PASEP": servidor.pis,
            SEXO: servidor.sexo,
            "ESTADO CIVIL": servidor.estadoCivil,
            "DATA DE NASCIMENTO": servidor.dataNascimento,
            "TIPO DE VÍNCULO": "1",
            "DATA DE INGRESSO NO SERV_PUBLICO": servidor.data_ingresso_serv,
            "DATA DE INGRESSO NO ENTE": servidor.dataIngressoEnte,
            "DATA DE INGRESSO NA CARREIRA ATUAL":
              servidor.dataIngressoCarreiraAtual,
            "IDENTIFICAÇÃO DA CARREIRA ATUAL": identificacaoCarreiraAtual,
            "DATA DE INÍCIO DE EXERCÍCIO NO CARGO ATUAL":
              servidor.dataInicioCargoAtual,
            "IDENTIFICAÇÃO DO CARGO ATUAL": servidor.cargoAtual,
            "BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO": servidor.salarioTotal,
            "REMUNERAÇÃO MENSAL TOTAL DO SERVIDOR ATIVO": servidor.salarioTotal,
            "CONTRIBUIÇÃO MENSAL": "",
            "PRIMEIRA BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO": "",
            "TEMPO DE CONTRIBUIÇÃO DO SERVIDOR ATIVO ANTERIOR À ADMISSÃO NO ENTE PARA O RGPS":
              servidor.tempoServicoAnteriorTotal,
            "NÚMERO DE DEPENDENTES DO SERVIDOR ATIVO":
              servidor.totalDependentes,
            "DATA DE NASCIMENTO DO CÔNJUGE OU COMPANHEIRO(A)":
              servidor.dataNascimentoConjugeOuCompanheiroAtivo,
            "CONDIÇÃO DO CÔNJUGE OU COMPANHEIRO(A)":
              servidor.condicaoConjugeOuCompanheiroAtivo,
            "DATA DE NASCIMENTO DO DEPENDENTE 2":
              servidor.dataNascimentoDependente2Ativo,
            "CONDIÇÃO DO DEPENDENTE 2": servidor.condicaoDependente2Ativo,
            "DATA DE NASCIMENTO DO DEPENDENTE 3":
              servidor.dataNascimentoDependente3Ativo,
            "CONDIÇÃO DO DEPENDENTE 3": servidor.condicaoDependente3Ativo,
            "DATA DE INÍCIO DE ABONO DE PERMANÊNCIA DO SERVIDOR ATIVO":
              servidor.data_abono,
            "PREVIDÊNCIA COMPLEMENTAR": "",
            "TETO REMUNERATÓRIO ESPECÍFICO": "",
            "RECENSEADO": recenseado,
            "NOME DO CONFERIDOR": servidor.nome_conferidor || "",
          };
          self.servidoresAtivos.push(data);
        } else if (servidor.status !== null && servidor.status == 3) {
          //PENSIONISTAS
          // Verificar se o servidor é recenseado
          const recenseado = servidor.inicio_atendimento && servidor.fim_atendimento ? "Sim" : "Não";
          
          let data = {
            ANO: servidor.ano,
            MÊS: servidor.mes,
            CO_IBGE: servidor.ibge,
            NOME_DO_ENTE: servidor.nome_cidade,
            SG_UF: servidor.estado_naturalidade,
            CO_COMP_MASSA: "1",
            CO_TIPO_FUNDO: tipoFundo,
            CNPJ: servidor.cnpj,
            "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
            "CO_PODER (CÓDIGO DO PODER)": poder,
            "CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)": tipoPoder,
            "CO_TIPO_INSTITUIDOR (CÓDIGO DO TIPO DE INSTITUIDOR)":
              servidor.administracao,
            "ID MATRICULA INSTITUIDOR": servidor.matricula_pensao,
            "INSTITUIDOR CPF": servidor.cpf_pensao,
            "INSTITUIDOR PIS PASEP": servidor.pis_pensao,
            "SEXO INSTITUIDOR": servidor.sexo_instituidor || "",
            DT_NASC_INSTITUIDOR: servidor.data_nascimento_pensao
              ? moment(servidor.data_nascimento_pensao).format("DD/MM/YYYY")
              : null,
            DT_OBITO_INSTITUIDOR: servidor.data_falecimento_pensao
              ? moment(servidor.data_falecimento_pensao).format("DD/MM/YYYY")
              : null,
            MATRICULA_PENSIONISTA: servidor.matricula,
            CPF_PENSIONISTA: servidor.cpf,
            SEXO: servidor.sexo,
            DT_NASC_PENSIONISTA: servidor.dataNascimento,
            "RELAÇÃO DO PENSIONISTA COM O INSTITUIDOR":
              servidor.relacao_titular_pensao,
            "DATA INICIO PENSAO": servidor.concessao_aposentadoria,
            "VALOR BENEF PENSAO": servidor.salarioBaseMensal,
            "VALOR TOTAL DA PENSÃO": servidor.salarioBaseMensal,
            VL_PCT_QUOTA: "",
            "VALOR CONTRIBUICAO": "",
            "VALOR MENSAL DA COMPENSAÇÃO PREVIDENCIÁRIA": "",
            PARIDADE: servidor.paridade_aposentadoria,
            "CONDIÇÃO DO PENSIONISTA": servidor.deficiente == 1 ? 2 : 1,
            "DURAÇÃO DO BENEFÍCIO": servidor.tipo_pensao,
            "TEMPO DURAÇÃO DO BENEFÍCIO": "",
            "PREVIDÊNCIA COMPLEMENTAR": "",
            "TETO REMUNERATÓRIO ESPECÍFICO": "",
            "RECENSEADO": recenseado,
            "NOME DO CONFERIDOR": servidor.nome_conferidor || "",
          };
          self.servidoresPensionistas.push(data);
        } else if (servidor.status != 4) {
          let tipo_aposentadoria = null

          if(servidor.tipo_aposentadoria == "Aposentadoria como Professor"){
            tipo_aposentadoria = 2
          }else{
            tipo_aposentadoria = 7
          }
          
          // Verificar se o servidor é recenseado
          const recenseado = servidor.inicio_atendimento && servidor.fim_atendimento ? "Sim" : "Não";
          
          //APOSENTADOS
          let data = {
            ANO: servidor.ano,
            MÊS: servidor.mes,
            CO_IBGE: servidor.ibge,
            NOME_DO_ENT: servidor.nome_cidade,
            SIGLA_ESTADO: servidor.estado_naturalidade,
            "COMPOSIÇÃO DA MASSA (A)": "1",
            "TIPO DE FUNDO (B)": servidor.fundo,
            CNPJ: servidor.cnpj,
            "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
            PODER: poder ? poder : "",
            "CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)": tipoPoder
              ? tipoPoder
              : "",
            TIPO_AUTARQUIA: servidor.administracao,
            CO_TIPO_POPULACAO: 4, //servidor.co_tipo_populacao,
            TIPO_CARGO: tipo_aposentadoria,//servidor.tipo_cargo,
            CO_TIPO_APOSENTADORIA:
              servidor.tipo_aposentadoria == null ||
              servidor.tipo_aposentadoria == undefined
                ? ""
                : servidor.tipo_aposentadoria,
            MATRÍCULA: servidor.matricula,
            CPF: servidor.cpf,
            "PIS-PASEP": servidor.pis,
            "SEXO DO APOSENTADO": servidor.sexo,
            "ESTADO CIVIL": servidor.estadoCivil,
            "DATA DE NASCIMENTO": servidor.dataNascimento,
            DT_ING_SERV_PUB: servidor.data_ingresso_serv,
            "DATA DE INGRESSO NO ENTE": servidor.dataIngressoEnte,
            DT_INICIO_APOSENTADORIA: servidor.concessao_aposentadoria,
            VL_APOSENTADORIA: servidor.salarioBaseMensal,
            VL_CONTRIBUICAO: "",
            VL_COMPENS_PREVID: "",
            IN_PARID_SERV: servidor.paridade_aposentadoria,
            CO_CONDICAO_APOSENTADO: "1",
            NU_TEMPO_RGPS_MUN: "",
            NU_TEMPO_RPPS: "",
            NU_DEPENDENTES: servidor.totalDependentes,
            "DATA DE NASCIMENTO DO CÔNJUGE OU COMPANHEIRO(A)":
              servidor.dataNascimentoConjugeOuCompanheiroAposentado,
            "CONDIÇÃO DO CÔNJUGE OU COMPANHEIRO(A)":
              servidor.condicaoConjugeOuCompanheiroAposentado,
            "DATA DE NASCIMENTO DO DEPENDENTE 2":
              servidor.dataNascimentoDependente2Aposentado,
            "CONDIÇÃO DO DEPENDENTE 2": servidor.condicaoDependente2Aposentado,
            "DATA DE NASCIMENTO DO DEPENDENTE 3":
              servidor.dataNascimentoDependente3Aposentado,
            "CONDIÇÃO DO DEPENDENTE 3": servidor.condicaoDependente3Aposentado,
            "PREVIDÊNCIA COMPLEMENTAR": "",
            "TETO REMUNERATÓRIO ESPECÍFICO": "",
            "RECENSEADO": recenseado,
            "NOME DO CONFERIDOR": servidor.nome_conferidor || "",
          };
          self.servidoresInativos.push(data);
        }
      }
      
      self.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(self.servidoresAtivos)),
        "servidoresativos"
      );
      self.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(self.servidoresInativos)),
        "servidoresinativos"
      );
      self.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(self.servidoresPensionistas)),
        "pensionistas"
      );
      this.spinner.hide();
    }
  }

  async gerarProvaDeVida() {
    const self = this;
    if (self.desabilitaRelatorio || !self.cidadeEscolhida || !self.statusServidorProvaVida || self.provaVidaEmAndamento) {
      return;
    }

    // Inicia o processamento paginado: lote a lote, acumulando os resultados.
    self.provaVidaEmAndamento = true;
    self.provaVidaProcessados = 0;
    self.provaVidaTotal = 0;
    self.provaVidaPaginaAtual = 0;
    self.provaVidaTotalPaginas = 0;
    // Garante que o overlay (em 0%) seja pintado antes da primeira requisição.
    await self.renderizarProgressoProvaVida();

    const acumulado = [];
    let pagina = 1;

    try {
      while (true) {
        // Timeout por lote: 30 CPFs * latência da Exato cabe folgado em 5 min.
        const call = self.api.new().silent();
        call.timeout = 5 * 60 * 1000;

        const relatorio = await call
          .post('exato/prova-de-vida', {
            id_cidade: self.cidadeEscolhida,
            status: self.statusServidorProvaVida,
            pagina,
            tamanho_lote: self.tamanhoLoteProvaVida,
          })
          .pipe(take(1))
          .toPromise();

        // Erro no lote -> abortar e descartar (não exporta nada).
        if (!relatorio || !Array.isArray(relatorio.resultados)) {
          self.provaVidaEmAndamento = false;
          self.cdr.detectChanges();
          this.app.alert(
            'Prova de Vida',
            `Falha ao processar o lote ${pagina}. O processamento foi interrompido e nenhum arquivo foi gerado. Tente novamente.`,
            'error'
          );
          return;
        }

        if (pagina === 1) {
          self.provaVidaTotal = relatorio.total || 0;
          self.provaVidaTotalPaginas = relatorio.total_paginas || 0;

          if (self.provaVidaTotal === 0) {
            self.provaVidaEmAndamento = false;
            self.cdr.detectChanges();
            this.app.alert('Prova de Vida', 'Nenhum servidor com CPF encontrado para o status selecionado.', 'warning');
            return;
          }
        }

        acumulado.push(...relatorio.resultados);
        self.provaVidaProcessados = acumulado.length;
        self.provaVidaPaginaAtual = pagina;
        // Re-renderiza a barra e cede o controle ao browser para repintar entre os lotes.
        await self.renderizarProgressoProvaVida();

        if (!relatorio.tem_proxima) {
          break;
        }
        pagina++;
      }
    } catch (e) {
      self.provaVidaEmAndamento = false;
      self.cdr.detectChanges();
      this.app.alert(
        'Prova de Vida',
        `Falha ao processar o lote ${pagina}. O processamento foi interrompido e nenhum arquivo foi gerado. Tente novamente.`,
        'error'
      );
      return;
    }

    // Remove o overlay imediatamente (antes da geração bloqueante do xlsx).
    self.provaVidaEmAndamento = false;
    self.cdr.detectChanges();

    const dados = acumulado.map((r) => ({
      'Nome': r.nome || '',
      'CPF': r.cpf || '',
      'Matrícula': r.matricula || '',
      'Status do Servidor': r.status_servidor_descricao || '',
      'Prova de Vida': r.prova_de_vida || '',
      'Consta Óbito': r.consta_obito === true ? 'Sim' : (r.consta_obito === false ? 'Não' : ''),
      'Situação Cadastral': r.situacao_cadastral || '',
      'Data de Óbito': r.data_obito || '',
      'Nome na Receita Federal': r.nome_receita_federal || '',
      'Data de Nascimento': r.data_nascimento || '',
      'Observação': r.erro || '',
    }));

    self.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(dados)),
      `prova_de_vida_${self.statusServidorProvaVida}`
    );
  }

  /** Percentual de progresso da prova de vida (0–100), com guarda para total zero. */
  provaVidaPercentual(): number {
    if (!this.provaVidaTotal) {
      return 0;
    }
    return Math.round((this.provaVidaProcessados / this.provaVidaTotal) * 100);
  }

  /**
   * Força a atualização da view (caso a chamada HTTP tenha rodado fora da zona do Angular)
   * e cede o controle ao browser por um tick, garantindo que a barra de progresso seja
   * repintada entre um lote e outro — em vez de "pular" só no fim.
   */
  private renderizarProgressoProvaVida(): Promise<void> {
    this.cdr.detectChanges();
    return new Promise((resolve) => setTimeout(resolve, 0));
  }

  getDisabledState(): boolean {
    if (this.desabilitaRelatorio) {
      return true;
    }
    switch(this.statusRelatorio) {
      case '7': return this.dependentesFiltered.length == 0;
      case '8': return this.temposServicoFiltered.length == 0;
      case '9': return this.servidoresComTotaisFiltered.length == 0;
      case '10': return this.listagemGeralFiltered.length == 0;
      case '11': return this.multiplasMatriculasFiltered.length == 0;
      case '12': return this.atendimentosFiltered.length == 0;
      case '13': return this.arquivosServidoresFiltered.length == 0;
      case '14': return true; // Prova de Vida usa o botão dedicado, não o "Gerar Relatório"
      case '15': return this.pendenciasFiltered.length == 0;
      default: return this.servidoresFiltered.length == 0;
    }
  }

  getEmptyState(): boolean {
    if (this.statusRelatorio == '14') {
      // Prova de Vida não exibe tabela; mantém a tela limpa sem o card de "vazio".
      return false;
    }
    switch(this.statusRelatorio) {
      case '7': return this.dependentes.length == 0;
      case '8': return this.temposServico.length == 0;
      case '9': return this.servidoresComTotais.length == 0;
      case '10': return this.listagemGeral.length == 0;
      case '11': return this.multiplasMatriculas.length == 0;
      case '12': return this.atendimentos.length == 0;
      case '13': return this.arquivosServidores.length == 0;
      case '15': return this.pendencias.length == 0;
      default: return this.servidores.length == 0;
    }
  }

  getEmptyMessage(): string {
    switch(this.statusRelatorio) {
      case '7': return 'Nenhum dependente encontrado.';
      case '8': return 'Nenhum tempo de serviço encontrado.';
      case '9': return 'Nenhum servidor com totais encontrado.';
      case '10': return 'Nenhum servidor encontrado na listagem geral.';
      case '11': return 'Nenhum servidor com múltiplas matrículas encontrado.';
      case '12': return 'Nenhum atendimento encontrado.';
      case '13': return 'Nenhum arquivo de servidor encontrado.';
      case '15': return 'Nenhuma pendência encontrada.';
      default: return 'Nenhum servidor encontrado.';
    }
  }

  padronizarSimNao(valor: any): string {
    // Debug: log do valor recebido
    console.log('Valor recebido para padronização:', valor, 'Tipo:', typeof valor);
    
    // Converter para string e normalizar
    const valorStr = String(valor).toLowerCase().trim();
    
    if (valorStr === 'sim' || valorStr === 's' || valorStr === '1' || valor === true || valor === 1) {
      return 'Sim';
    }
    return 'Não';
  }
  async pesquisarPorDataNascimentoMaximoDatePicker(){
    if(this.dataNascimentoMinima && this.dataNascimentoMaxima) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/data_nascimento?id_cidade=${this.cidadeEscolhida}&data_nascimento_inicio=${this.dataNascimentoMinima}&data_nascimento_fim=${this.dataNascimentoMaxima}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorDataNascimentoMaximo(){
    if(this.dataNascimentoMinima && this.dataNascimentoMaxima) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/data_nascimento?id_cidade=${this.cidadeEscolhida}&data_nascimento_inicio=${this.dataNascimentoMinima}&data_nascimento_fim=${this.dataNascimentoMaxima}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorDataNascimentoDependenteMinimoDatePicker(){
    if(this.dataNascimentoDependenteMinima && this.dataNascimentoDependenteMaxima) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/data_nascimento_dependente?id_cidade=${this.cidadeEscolhida}&data_nascimento_inicio=${this.dataNascimentoDependenteMinima}&data_nascimento_fim=${this.dataNascimentoDependenteMaxima}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorDataNascimentoDependenteMinimo(){
    if(this.dataNascimentoDependenteMinima && this.dataNascimentoDependenteMaxima) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/data_nascimento_dependente?id_cidade=${this.cidadeEscolhida}&data_nascimento_inicio=${this.dataNascimentoDependenteMinima}&data_nascimento_fim=${this.dataNascimentoDependenteMaxima}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }

  }
  async pesquisarPorDataNascimentoDependenteMaximoDatePicker(){
    if(this.dataNascimentoDependenteMinima && this.dataNascimentoDependenteMaxima) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/data_nascimento_dependente?id_cidade=${this.cidadeEscolhida}&data_nascimento_inicio=${this.dataNascimentoDependenteMinima}&data_nascimento_fim=${this.dataNascimentoDependenteMaxima}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }
  async pesquisarPorDataNascimentoDependenteMaximo(){
    if(this.dataNascimentoDependenteMinima && this.dataNascimentoDependenteMaxima) {
      this.servidores = []
      this.servidoresFiltered = []
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      const servidores = await this.apiCall.get(`servidor/relatorio/data_nascimento_dependente?id_cidade=${this.cidadeEscolhida}&data_nascimento_inicio=${this.dataNascimentoDependenteMinima}&data_nascimento_fim=${this.dataNascimentoDependenteMaxima}`).pipe(take(1)).toPromise()
      this.servidores = JSON.parse(JSON.stringify(servidores));
      this.servidoresFiltered = JSON.parse(JSON.stringify(servidores));
      this.spinner.hide();
    }
  }

}
